import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    productCategoryList: [],
    productSubCategoryList: [],
    unitInfoList: [],
    designationInfoList: [],
    productList: [],
    productUnitList: [],
    productTypeList: Custom.productTypeLists,
    salesCenterList: [],
    monthList: Custom.monthList,
    registrationStatusList: Custom.registrationStatusList,
    registrationTypeList: [
        {
            value: 1,
            text_en: 'Dealer',
            text_bn: 'ডিলার'
        },
        {
            value: 2,
            text_en: 'Retailer',
            text_bn: 'খুচরা বিক্রেতা'
        }
    ],
    paymentTypeList: [
        {
            value: 1,
            text_en: 'Online Payment',
            text_bn: 'অনলাইন পেমেন্ট'
        },
        {
            value: 2,
            text_en: 'Check Payment',
            text_bn: 'চেক পেমেন্ট'
        },
        {
            value: 3,
            text_en: 'Cash Payment',
            text_bn: 'ক্যাশ পেমেন্ট'
        },
        {
            value: 4,
            text_en: 'Others Payment',
            text_bn: 'অন্যান্য পেমেন্ট'
        }
    ],
    promotionTypeList: [],
    dealerRetailerList: [],
    supplierInfoList: []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
